"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeCache = void 0;
const node_cache_1 = __importDefault(require("node-cache"));
function nodeCache() {
    const internalCache = new node_cache_1.default();
    return {
        async get(key) {
            return internalCache.get(key);
        },
        async set(key, value, { ttl }) {
            if (ttl) {
                return internalCache.set(key, value, ttl);
            }
            return internalCache.set(key, value);
        },
        async del(key) {
            return internalCache.del(key);
        },
        async getOrCreate(key, creator, options) {
            const cachedValue = await this.get(key);
            if (cachedValue)
                return cachedValue;
            const value = await creator();
            await this.set(key, value, options);
            return value;
        },
        async miss(key, value, options) {
            if (await this.get(key))
                return false;
            return this.set(key, value, options);
        },
        async flushAll() {
            internalCache.flushAll();
        },
    };
}
exports.nodeCache = nodeCache;
//# sourceMappingURL=node-cache.js.map